import { render, staticRenderFns } from "./iframereuters.vue?vue&type=template&id=9913fa70&"
import script from "./iframereuters.vue?vue&type=script&lang=js&"
export * from "./iframereuters.vue?vue&type=script&lang=js&"
import style0 from "./iframereuters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports